import { json } from '../c-mp/fun/json'

const blobs = new Map<string, Blob>()

export async function fetchImageToBlob(url: string): Promise<Blob | undefined> {
	const blob = blobs.get(url)
	if (blob) return blob
	const response = await fetch(url)
	if (response.ok) {
		const blob = await response.blob()
		blobs.set(url, blob)
		return blob
	} else if (response.status === 404) {
		return undefined
	} else {
		throw new Error(json`[t9hat7] ${response.status} ${response.statusText}`)
	}
}
